import React, { useState } from "react";
import { useNavigate,Link } from "react-router-dom"; // Import for routing
import { FaPhoneAlt, FaSearch, FaCheck, FaArrowRight } from "react-icons/fa";
import "../Css/HouseMaid.css";
import HouseMaidImage from "../assets/service-3.jpg";




const HouseMaid = () => {

    const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");

  // List of your services
  const services = [
  { name: "Patient Care", path: "/services/patient-care-service-in-mumbai" },
  { name: "Baby Care", path: "/services/baby-care-service-in-mumbai" },
  { name: "House Maid", path: "/services/house-maid-service-in-mumbai" },
  { name: "Cooking", path: "/services/cooking-service-in-mumbai" },
  { name: "Driver", path: "/services/driver-service-in-mumbai" },
  { name: "Home Cleaning", path: "/services/home-cleaning-service-in-mumbai" },
  { name: "Japa Maid", path: "/services/japa-maid-service-in-mumbai" },
];

  // Filter logic
  const filteredServices = services.filter((item) =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  
  return (
    <div className="HouseMaid-page">
      {/* HERO SECTION - RETAINED AS REQUESTED */}
      <section className="HouseMaid-hero">
        <div className="HouseMaid-overlay">
          <div className="HouseMaid-hero-content">
            <h1>House Maid</h1>
            <p>
              <span><a href="/">Home</a></span> / <span className="active">House Maid</span>
            </p>
          </div>
        </div>
      </section>

      {/* SQUARE PREMIUM CONTENT */}
      <section className="main-section">
        <div className="container-square">
          <div className="content-layout">
            
            {/* Main Content Area */}
            <div className="article-box">
              <div className="square-img-holder">
                <img src={HouseMaidImage} alt="House Maid Services" />
                <div className="img-overlay-label">PREMIUM SERVICE</div>
              </div>

              <div className="text-header">
                <h2 className="title-bold">Trusted House Maid Services in Mumbai – Reliable & Experienced</h2>
                <h4 className="subtitle-line">Full-Time and Part-Time Maids Mumbai</h4>
              </div>

              <div className="body-description">
                <p>Tanya Maid Service is a leading provider of Full Time House Maid Mumbai, offering reliable, skilled, and professional domestic help across Mumbai. We understand that managing a household can be challenging, which is why our Trusted Maid Services Mumbai are designed to make your home life easier, cleaner, and more organized.</p>
                <p>Our Professional Home Maid Mumbai are trained to perform all household duties with care and efficiency. From daily cleaning and laundry to cooking and managing household errands, our maids ensure that your home runs smoothly while maintaining the highest standards of hygiene and professionalism.</p>
                <p>At Tanya Maid Service, we pride ourselves on offering Experienced Domestic Help Mumbai who are background-verified, trustworthy, and dedicated to making your life stress-free. Whether you require assistance with routine housekeeping or specialized home management, we have the right solution to meet your needs.</p>
                
              </div>

              {/* Why Choose - Modern Square Grid */}
              <div className="why-choose-square">
                <h3>Why Choose Tanya Maid Service?</h3>
                <div className="grid-features">
                  <div className="feature-square">
                    <FaCheck className="blue-icon" />
                    <p><strong>Full Time House Maid Mumbai:</strong> Dedicated maids available for full-time support to manage all household tasks.</p>
                  </div>
                  <div className="feature-square">
                    <FaCheck className="blue-icon" />
                    <p><strong>Reliable Housekeeping Services Mumbai:</strong> Ensuring your home is spotless, hygienic, and well-organized every day.</p>
                  </div>
                  <div className="feature-square">
                    <FaCheck className="blue-icon" />
                    <p><strong>Trusted Maid Services Mumbai:</strong> Verified and professional staff you can rely on for safety and efficiency.</p>
                  </div>
                  <div className="feature-square">
                    <FaCheck className="blue-icon" />
                    <p><strong>Professional Home Maid Mumbai:</strong> Skilled in cooking, cleaning, laundry, and other essential home tasks.</p>
                  </div>
                  <div className="feature-square">
                    <FaCheck className="blue-icon" />
                    <p><strong>Experienced Domestic Help Mumbai:</strong> Trained and capable staff who adapt to your household routines.</p>
                  </div>
                  <div className="feature-square">
                    <FaCheck className="blue-icon" />
                    <p><strong>Flexible and Supportive:</strong> Services customized to suit your schedule and specific requirements.</p>
                  </div>
                </div>
              </div>

              <div className="summary-footer-box">
                <p>Our Full Time House Maid Mumbai not only help with daily chores but also provide a sense of comfort and consistency in your home. Families across Mumbai trust Tanya Maid Service for our commitment to quality, reliability, and professionalism.</p>
              </div>
              <div className="summary-footer-box">
                <p>By choosing Tanya Maid Service, you can experience the convenience of having a dedicated domestic helper who manages your home efficiently. Our Professional Home Maid Mumbai and Experienced Domestic Help Mumbai ensure that every task is handled with precision, making us one of the most preferred providers of Trusted Maid Services Mumbai.</p>
              </div>
              <div className="summary-footer-box">
                <p>Let Tanya Maid Service take care of your home with our reliable, professional, and skilled Full Time House Maid Mumbai, so you can focus on your family, work, and personal life without worrying about household chores.</p>
              </div>
            </div>

            {/* Square Sidebar */}
            <aside className="sidebar-square">
              {/* ACTIVE SEARCH BOX */}
      <div className="search-container-premium">
        <div className="search-square">
          <input
            type="text"
            placeholder="SEARCH SERVICES..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <button><FaSearch /></button>
        </div>

        {/* Search Results Dropdown */}
        {searchTerm && (
          <div className="search-results-dropdown">
            {filteredServices.length > 0 ? (
              filteredServices.map((service, index) => (
                <div
                  key={index}
                  className="result-item"
                  onClick={() => navigate(service.path)}
                >
                  {service.name}
                </div>
              ))
            ) : (
              <div className="no-result">No services found</div>
            )}
          </div>
        )}
      </div>

              <div className="list-widget">
                <h5>OUR SERVICES</h5>
                <ul className="square-links">
  <li>
    <Link to="/services/patient-care-service-in-mumbai">
      Patient Care <FaArrowRight />
    </Link>
  </li>

  <li>
    <Link to="/services/baby-care-service-in-mumbai">
      Baby Care <FaArrowRight />
    </Link>
  </li>

  <li>
    <Link
      to="/services/house-maid-service-in-mumbai"
      className="active-item"
    >
      House Maid <FaArrowRight />
    </Link>
  </li>

  <li>
    <Link to="/services/cooking-service-in-mumbai">
      Cooking <FaArrowRight />
    </Link>
  </li>

  <li>
    <Link to="/services/driver-service-in-mumbai">
      Driver <FaArrowRight />
    </Link>
  </li>

  <li>
    <Link to="/services/home-cleaning-service-in-mumbai">
      Home Cleaning <FaArrowRight />
    </Link>
  </li>

  <li>
    <Link to="/services/japa-maid-service-in-mumbai">
      Japa Maid <FaArrowRight />
    </Link>
  </li>
</ul>
              </div>

<div className="contact-box-square">
  <div className="cta-overlay-square">
    <div className="cta-icon-square">
      <FaPhoneAlt />
    </div>
    <h3 className="cta-title-square">Call us Today!</h3>
    <a href="tel:+917304398067" className="cta-phone-square">
      +91 73043 98067
    </a>
    <a href="mailto:info@tanyamaidservice.com" className="cta-email-square">
      info@tanyamaidservice.com
    </a>
  </div>
</div>
            </aside>

          </div>
        </div>
      </section>
    </div>
  );
};

export default HouseMaid;